import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-batch-trigger-dialog',
  templateUrl: './batch-trigger-dialog.component.html',
  styleUrls: ['./batch-trigger-dialog.component.scss'],
})
export class BatchTriggerDialogComponent implements OnInit {
  editEventEmitter = new EventEmitter();
  warningMessage = '';
  successMessage = '';
  selectedDock: any;
  selectedPart: any;
  selectedKanban: any;
  partNo: any;
  dock: any;
  disablePartNumber: boolean;
  disableKanban: boolean;
  selectedDate: any;
  dockList: any = [];
  partList: any = [];
  kanbanList: any = [];
  dataLabel: any;
  isMonthlyPipeline = false;
  data1;
  timezone;
  disableTriggerButton = false;
  displaywarningmsg: string;
  rerun: string = 'no'

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any = {},
    private readonly dialogeRef: MatDialogRef<BatchTriggerDialogComponent>
  ) {}

  ngOnInit(): void {
    this.dataLabel = this.data?.dataLabel;
    this.isMonthlyPipeline = this.data?.isMonthlyPipeline;
    this.data1 = this.data?.data1;
    this.data = this.data?.qpcForPart;
    this.displaywarningmsg = 'Monthly pipeline Batch trigger functionality is not yet available.';


if (this.isMonthlyPipeline && this.data1?.length) {
  this.timezone =
    localStorage.getItem('timezone') || 'UTC';

  const today = moment.tz(this.timezone);

  const parseDate = (dateStr: string) => {
    if (!dateStr) {
      return null;
    }

    return moment.tz(
      dateStr,
      'MM/DD/YYYY HH:mm:ss',
      true,
      this.timezone
    );
  };

  const isCurrentMonth = (dateStr: string) => {
    const date = parseDate(dateStr);

    if (!date || !date.isValid()) {
      return false;
    }

    return (
      date.month() === today.month() &&
      date.year() === today.year()
    );
  };

  const llpBatch = this.data1.find(
    (item) =>
      item.batch_name?.trim().toLowerCase() ===
      'monthly pipeline addition batch'
  );

  const pitchBatch = this.data1.find(
    (item) =>
      item.batch_name?.trim().toLowerCase() ===
      'pitch calculation batch'
  );

  const llpCurrentMonth = isCurrentMonth(
    llpBatch?.start_date
  );

  const pitchCurrentMonth = isCurrentMonth(
    pitchBatch?.start_date
  );

  const pitchCompleted =
    pitchBatch?.status?.toUpperCase() === 'COMPLETE';

  const llpRunning =
    llpBatch?.status?.toUpperCase() === 'RUNNING';

  // Default values
  this.disableTriggerButton = false;
  this.displaywarningmsg = '';

  // Requirement #1
  if (!pitchCurrentMonth || !pitchCompleted) {
    this.disableTriggerButton = true;

    this.displaywarningmsg =
      'Monthly pipeline Addition batch cannot trigger until pitch batch is completed for the current month';

    return;
  }

  // Requirement #2
  if (llpCurrentMonth && llpRunning) {
    this.disableTriggerButton = true;

    this.displaywarningmsg =
      'Monthly pipeline Addition batch cannot trigger until previous execution is completed';

    return;
  }

  // false = first run of current month
  // true = monthly rerunconsole.log('Before rerun assignment');
this.rerun = llpCurrentMonth ? 'yes' : 'no';

console.log('llpCurrentMonth', llpCurrentMonth);
console.log('rerun', this.rerun);

  console.log(
    'today:',
    today.format('YYYY-MM-DD HH:mm:ss Z')
  );

  console.log(
    'llp date:',
    llpBatch?.start_date,
    parseDate(llpBatch?.start_date)?.format(
      'YYYY-MM-DD HH:mm:ss Z'
    )
  );

  console.log(
    'pitch date:',
    pitchBatch?.start_date,
    parseDate(pitchBatch?.start_date)?.format(
      'YYYY-MM-DD HH:mm:ss Z'
    )
  );

  console.log('llpCurrentMonth:', llpCurrentMonth);
  console.log('pitchCurrentMonth:', pitchCurrentMonth);
  console.log('pitchCompleted:', pitchCompleted);
  console.log('llpRunning:', llpRunning);
  console.log('rerun:', this.rerun);
  console.log(
    'disableTriggerButton:',
    this.disableTriggerButton
  );
}

    type DockItem = { dock: string };

    const uniqueDocks = new Set<string>();

   

    this.data.forEach((item) => {
      if (item.dock) {
        uniqueDocks.add(item.dock);
      }
    });

    // this.dockList = Array.from(uniqueDocks).map((dock): DockItem => ({ dock }));
    // console.log(this.dockList,'dockList')
    this.dockList = Array.from(uniqueDocks)
      .map((dock): DockItem => ({ dock }))
      .sort((a, b) => a.dock.localeCompare(b.dock));
    // this.partList = this.data.map((obj) => ({ item_id: obj.item_id }));

    // this.dockList= this.data.filter((ele:any)=>)
    // this.business_entity=localStorage.getItem('namcvalue')
    // if(this.data=='negative'){
    //   this.showCanceledPopUP=true

    // }
  }
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }

  triggerBatch() {
      if (this.isMonthlyPipeline) {
        const data = {
        batch_name: this.data?.batch_name,
        rerun : this.rerun     };

      this.editEventEmitter.emit(data);
      this.dialogeRef.close();
    

    return; 
  }

    if (!this.selectedDock?.dock) {
      this.warningMessage = 'Please select mandatory fields.';
      return;
    } else {
      const data = {
        dock: this.selectedDock?.dock,
        item_id: this.selectedPart?.item_id,
        batch_name: this.data?.batch_name,
        current_date: this.selectedDate ? this.selectedDate : '',
      };

      this.editEventEmitter.emit(data);
      this.dialogeRef.close();
    }
  }

  // onDockChange() {
  //   this.disableKanban = false;
  //   this.disablePartNumber = false;

  //   this.kanbanList = [];
  //   this.partList = [];

  //   this.selectedKanban = [];
  //   this.selectedPart = [];
  //   // partList: unique and sorted by item_id
  //   const uniqueParts = new Set();
  //   this.partList = this.data
  //     .filter((item) => {
  //       if (!uniqueParts.has(item.item_id)) {
  //         uniqueParts.add(item.item_id);
  //         return true;
  //       }
  //       return false;
  //     })
  //     .map((item) => ({ item_id: item.item_id }))
  //     .sort((a, b) => parseInt(a.item_id) - parseInt(b.item_id));

  //   // kanbanList: unique and sorted by kanban
  //   const uniqueKanbans = new Set();
  //   this.kanbanList = this.data
  //     .filter((item) => {
  //       if (!uniqueKanbans.has(item.kanban)) {
  //         uniqueKanbans.add(item.kanban);
  //         return true;
  //       }
  //       return false;
  //     })
  //     .map((item) => ({ kanban: item.kanban }))
  //     .sort((a, b) => parseInt(a.kanban) - parseInt(b.kanban));
  // }

  onDockChange(): void {
    // Reset disable flags
    this.disableKanban = false;
    this.disablePartNumber = false;

    this.kanbanList = [];
    this.partList = [];

    this.selectedKanban = [];
    this.selectedPart = [];

    if (this.selectedDock.length >= 1) {
      this.selectedDock = {
        dock: [this.selectedDock.dock],
      };
    }

    const selectedDockVal = this.selectedDock?.dock;

    if (selectedDockVal) {
      const pmList = this.data.filter((element) => element.dock === selectedDockVal);

      // Create kanban list without duplicates
      const uniqueKanbans = new Set();
      this.kanbanList = pmList
        .filter((item) => {
          if (!uniqueKanbans.has(item.kanban)) {
            uniqueKanbans.add(item.kanban);
            return true;
          }
          return false;
        })
        .map((item) => ({ kanban: item.kanban }))
        .sort((a, b) => parseInt(a.kanban) - parseInt(b.kanban));

      // Create part number list without duplicates
      const uniqueParts = new Set();
      this.partList = pmList
        .filter((item) => {
          if (!uniqueParts.has(item.item_id)) {
            uniqueParts.add(item.item_id);
            return true;
          }
          return false;
        })
        .map((item) => ({ item_id: item.item_id }))
        .sort((a, b) => parseInt(a.item_id) - parseInt(b.item_id));
    }
  }

  onPartNoChange(): void {
    if (this.selectedPart && this.selectedPart.item_id) {
      this.selectedPart = {
        item_id: this.selectedPart.item_id,
      };

      this.disableKanban = true;

      //  New code starts here
      const part_no = this.selectedPart?.item_id;
      const dock = this.selectedDock?.dock;

      const matchingItem = this.data.find((entry) => entry.item_id === part_no && entry.dock === dock);
      console.log(matchingItem);

      if (matchingItem) {
        this.selectedKanban = { kanban: matchingItem.kanban };
        // this.selectedKanban = {
        //   kanban: this.selectedKanban.kanban,
        // };
      } else {
        this.selectedKanban = null;
      }
      // 💡 New code ends here
    } else {
      this.disableKanban = false;
    }
  }

  onKanbanChange(): void {
    if (this.selectedKanban && this.selectedKanban.kanban) {
      this.selectedKanban = {
        kanban: this.selectedKanban.kanban,
      };

      this.disablePartNumber = true;

      const kanbanNo = this.selectedKanban?.kanban;
      const dock = this.selectedDock?.dock;
      const matchingItem = this.data.find((entry) => entry.kanban === kanbanNo && entry.dock === dock);
      console.log(matchingItem);

      if (matchingItem) {
        this.selectedPart = { item_id: matchingItem.item_id };
      } else {
        this.selectedPart = null;
      }
    } else {
      this.disablePartNumber = false;
    }
  }
}
